/*
 * ta-button — premium interactions for .ta-btn--arrow CTAs
 *
 *  - Magnetic hover: the button (and its arrow circle, with extra parallax)
 *    leans toward the cursor via --ta-mx/--ta-my custom properties.
 *  - Loading state: on a real navigation click the arrow morphs into a
 *    spinner (.is-loading) until the page unloads.
 *
 * Idempotent + theme-editor aware. Magnetism is disabled for reduced-motion
 * and for coarse (touch) pointers.
 */
(function () {
  'use strict';

  if (window.__taButtonInit) return;
  window.__taButtonInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // How far the elements drift toward the cursor (fraction of the offset).
  var BTN_STRENGTH = 0.06;
  var ICON_STRENGTH = 0.12;

  function bindMagnet(btn) {
    if (btn.dataset.taMagnet) return;
    btn.dataset.taMagnet = '1';

    var icon = btn.querySelector('.ta-btn__icon');
    var raf = null;
    var rect = null;

    function onEnter() {
      rect = btn.getBoundingClientRect();
    }

    function onMove(e) {
      if (!rect) rect = btn.getBoundingClientRect();
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var dx = e.clientX - (rect.left + rect.width / 2);
        var dy = e.clientY - (rect.top + rect.height / 2);
        btn.style.setProperty('--ta-mx', (dx * BTN_STRENGTH).toFixed(2) + 'px');
        btn.style.setProperty('--ta-my', (dy * BTN_STRENGTH).toFixed(2) + 'px');
        if (icon) {
          var ix = dx * (ICON_STRENGTH - BTN_STRENGTH);
          var iy = dy * (ICON_STRENGTH - BTN_STRENGTH);
          icon.style.setProperty('--ta-imx', ix.toFixed(2) + 'px');
          icon.style.setProperty('--ta-imy', iy.toFixed(2) + 'px');
        }
      });
    }

    function reset() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      rect = null;
      btn.style.setProperty('--ta-mx', '0px');
      btn.style.setProperty('--ta-my', '0px');
      if (icon) {
        icon.style.setProperty('--ta-imx', '0px');
        icon.style.setProperty('--ta-imy', '0px');
      }
    }

    btn.addEventListener('pointerenter', onEnter);
    btn.addEventListener('pointermove', onMove);
    btn.addEventListener('pointerleave', reset);
    btn.addEventListener('blur', reset);
  }

  // Treat the click as a navigation only when the browser will actually leave
  // the page (no modifier keys, same tab, real destination URL).
  function isRealNavigation(btn, e) {
    if (e.defaultPrevented) return false;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (btn.target && btn.target !== '_self') return false;
    var href = btn.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (/^(javascript|mailto|tel):/i.test(href)) return false;
    return true;
  }

  function bindLoading(btn) {
    if (btn.dataset.taLoading) return;
    btn.dataset.taLoading = '1';
    btn.addEventListener('click', function (e) {
      if (btn.tagName === 'A' && !isRealNavigation(btn, e)) return;
      btn.classList.add('is-loading');
    });
  }

  function init(scope) {
    var btns = (scope || document).querySelectorAll('.ta-btn--arrow');
    for (var i = 0; i < btns.length; i++) {
      if (finePointer && !reduceMotion) bindMagnet(btns[i]);
      bindLoading(btns[i]);
    }
  }

  function start() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Clear the spinner if the user returns via the bfcache (back button).
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var btns = document.querySelectorAll('.ta-btn--arrow.is-loading');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('is-loading');
  });

  // Shopify theme editor re-renders sections without a full reload.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
